export default {
  // layout
  LAYOUT: {
    header: {
    },
    footer: {
    },
    uploading: {
    }
  },
  // page
  PAGE: {
  },
  // component
  COMPONENT: {
    dialog: {
      toast: {
      }
    }
  },
  // common
  COMMON: {
    button: {
    },
    toast: {
    }
  }
}
